import {
    CORE_LOAD_RESOURCES_REQUEST,
    CORE_LOAD_RESOURCES_SUCCESS,
    CORE_LOAD_RESOURCES_FAILURE,
    CORE_LOAD_WAREHOUSES_REQUEST,
    CORE_LOAD_WAREHOUSES_SUCCESS,
    CORE_LOAD_WAREHOUSES_FAILURE,
    CORE_LOAD_SCRAPS_REQUEST,
    CORE_LOAD_SCRAPS_SUCCESS,
    CORE_LOAD_SCRAPS_FAILURE,
    CORE_LOAD_MATERIALS_BY_WAREHOUSE_ID_REQUEST,
    CORE_LOAD_MATERIALS_BY_WAREHOUSE_ID_SUCCESS,
    CORE_LOAD_MATERIALS_BY_WAREHOUSE_ID_FAILURE,
} from '../types';
import { REQUEST_STATE } from '../types';

const requestState = REQUEST_STATE;

export default {
    resources: (state = requestState, action) => {
        switch (action.type) {
            case CORE_LOAD_RESOURCES_REQUEST:
                return state;
            case CORE_LOAD_RESOURCES_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload;
                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }
            case CORE_LOAD_RESOURCES_FAILURE:
                return [];
            default:
                return state;
        }
    },

    warehouses: (state = requestState, action) => {
        switch (action.type) {
            case CORE_LOAD_WAREHOUSES_REQUEST:
                return state;
            case CORE_LOAD_WAREHOUSES_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload;
                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }
            case CORE_LOAD_WAREHOUSES_FAILURE:
                return [];
            default:
                return state;
        }
    },

    scraps: (state = requestState, action) => {
        switch (action.type) {
            case CORE_LOAD_SCRAPS_REQUEST:
                return state;
            case CORE_LOAD_SCRAPS_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload;
                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }
            case CORE_LOAD_SCRAPS_FAILURE:
                return [];
            default:
                return state;
        }
    },

    materials: (state = requestState, action) => {
        switch (action.type) {
            case CORE_LOAD_MATERIALS_BY_WAREHOUSE_ID_REQUEST:
                return state;
            case CORE_LOAD_MATERIALS_BY_WAREHOUSE_ID_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload;
                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }
            case CORE_LOAD_MATERIALS_BY_WAREHOUSE_ID_FAILURE:
                return [];
            default:
                return state;
        }
    },

    // masterStation: (state = requestState, action) => {
    //     switch (action.type) {
    //         case CORE_LOAD_MASTER_DATA_STATION_REQUEST:
    //             return state
    //         case CORE_LOAD_MASTER_DATA_STATION_SUCCESS:
    //             if (action.payload) {
    //                 const { result, data } = action.payload
    //                 if (result && data) {
    //                     return data
    //                 } else return {}
    //             } else {
    //                 return {}
    //             }
    //         case CORE_LOAD_MASTER_DATA_STATION_FAILURE:
    //             return {}
    //         default:
    //             return state
    //     }
    // },
};



// WEBPACK FOOTER //
// ./src/app/redux/reducers/axData.js